import { render } from "./delivery-messaging.vue?vue&type=template&id=951d61e8"
import script from "./delivery-messaging.vue?vue&type=script&lang=js"
export * from "./delivery-messaging.vue?vue&type=script&lang=js"

import "./delivery-messaging.vue?vue&type=style&index=0&id=951d61e8&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__